// Footer.jsx
import React from 'react';
import { FaWhatsapp, FaInstagram, FaFacebook, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-icons">
        <a href="https://wa.me/03095195765" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp className="icon" />
        </a>
        <a href="https://www.instagram.com/yourinstagramhandle" target="_blank" rel="noopener noreferrer">
          <FaInstagram className="icon" />
        </a>
        <a href="https://www.facebook.com/profile.php?id=61559766597754&mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
          <FaFacebook className="icon" />
        </a>
        <a href="mailto:yourgmailaddress@gmail.com">
          <FaEnvelope className="icon" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
